import React from 'react'
import { useState } from 'react';
import Pagination from '../../../utils/Pagination';
import '../product.css'

export default function ProductList({entitleFilterData,addedNewProduct, adddedProduct, removeProduct}) {
	const [paginationDetails, setPaginationDetails] = useState({
		currentPage: 1,
		posts: [],
		loading: null,
		postsPerPage: 15
	});
	const [searched, setsearched] = useState('')
	const indexOfLastPost = paginationDetails.currentPage * paginationDetails.postsPerPage;

	const indexOfFirstPost = indexOfLastPost - paginationDetails.postsPerPage;
  const currentPosts = entitleFilterData !== undefined && entitleFilterData !== '' && Array.isArray(entitleFilterData)  &&  entitleFilterData.filter((val) => {
		if (searched === '') {
			return val
		} else if (val.id !== undefined && val?.id.toLowerCase().includes(searched.toLowerCase())) {
			return val
		}
	}).slice(indexOfFirstPost, indexOfLastPost);
  return (
    <div class="productlist">
					<div class="table-responsive">
						<table class="table">
                            <tbody>
							<tr>
								{/* <th>
									<div class="custom-control custom-checkbox">
									  <input type="checkbox" class="custom-control-input" id="chh1" checked/>
									  <label class="custom-control-label" for="chh1"></label>
									</div>
								</th> */}
								<th>Product Name</th>								
								<th>Action</th>
							</tr>
							{
							 Array.isArray(currentPosts) && currentPosts.length > 0 && 
							 currentPosts.map((product, index)=>{
								return <tr key={index} >
								{/* <td>
									<div class="custom-control custom-checkbox">
									  <input type="checkbox" class="custom-control-input" id="chh2"/>
									  <label class="custom-control-label" for="chh2"></label>
									</div>
								</td> */}
								<td>{ product?.id !== undefined && product.id !== null && product.id }</td>
								<td> { Array.isArray(adddedProduct) &&  adddedProduct.includes(product.id) ?  <button type="button" class="lbbtnremove" onClick={()=>removeProduct(product.id)} >Remove</button> :<button type="button" class="lbbtn" onClick={()=>addedNewProduct(product)} >Add</button> } </td>
							     </tr>
							 })
							}	
						
                            </tbody>
						</table>
					</div>
				
					<div class="row">
						<div class="col-12 col-md-6">
							<div class="totalno">Showing 1 to {Array.isArray(entitleFilterData) && entitleFilterData.length}</div>
						</div>
						{
                       Array.isArray(entitleFilterData) && entitleFilterData.length > 15  && searched == "" &&
					   <div class="col-12 col-md-6">
                     <Pagination
                     className="pagination-bar"
                     currentPage={paginationDetails.currentPage}
                     totalCount={  Array.isArray(entitleFilterData) && entitleFilterData.length}
                     pageSize={paginationDetails.postsPerPage}
                     onPageChange={page => setPaginationDetails((prev)=> {return({...prev, currentPage:page})})}
                     />
					 </div>
                    }
						{/* <div class="col-12 col-md-6">
							<nav class="pager">
								<ul class="pagination pagination-sm">
									<li class="page-item disabled"><span class="page-link">Prev</span></li>
									<li class="page-item active"><span class="page-link">1</span></li>
									<li class="page-item"><a class="page-link" href="#">2</a></li>
									<li class="page-item"><a class="page-link" href="#">3</a></li>
									<li class="page-item"><a class="page-link" href="#">Next</a></li>
								</ul>
							</nav>
						</div> */}
					</div>
				</div>	
  )
}
